import React from 'react';
import { observer } from 'mobx-react';
import { StringStore } from 'ui/base/input/store';
import { InputChangeEvent, InputProps } from 'ui/base/types';

// unlike TextInput, the "type" is a valid prop that can be used to override
// the default "url". For example, using "text" means that we want the URL
// keyboard to appear but we don't want to validate the resulting input.
// useful if we don't want to require adding the protocol ("https://").
export type URLInputProps = Omit<InputProps, 'value' | 'onChange'> & {
  store: StringStore;
};

export const URLInput = observer(({ store, ...props }: URLInputProps) => {
  const onChange = React.useCallback((event: InputChangeEvent) => {
    store.setValue(event.target.value);
  }, [store]);

  return <input type={props.type ?? 'url'} inputMode='url' value={store.value} onChange={onChange} {...props}/>;
});
